export const INCREMENT_CART = "INCREMENT_CART";
export const DECREMENT_CART = "DECREMENT_CART";
export const INCREMENT_UNPAID_CART = "INCREMENT_UNPAID_CART";
export const DECREMENT_UNPAID_CART = "DECREMENT_UNPAID_CART";
export const SET_CART_COUNT = "SET_CART_COUNT";
export const SET_UNPAID_CART_COUNT = "SET_UNPAID_CART_COUNT";

export const incrementCart = () => ({ type: INCREMENT_CART });
export const decrementCart = () => ({ type: DECREMENT_CART });
export const incrementUnpaidCart = () => ({ type: INCREMENT_UNPAID_CART });
export const decrementUnpaidCart = () => ({ type: DECREMENT_UNPAID_CART });
export const setCartCount = (count) => ({
  type: SET_CART_COUNT,
  payload: count,
});
export const setUnpaidCartCount = (count) => ({
  type: SET_UNPAID_CART_COUNT,
  payload: count,
});
